// extracted by mini-css-extract-plugin
export default {"header":"Shipment_header__sbW4i","next":"Shipment_next__tDfuc","message_title":"Shipment_message_title__Ov9on","error":"Shipment_error__1Tr4S"};